import { Injectable } from '@angular/core';

@Injectable()
export abstract class ICreateShipmentPopup {
    abstract OpenCreateShipmentPopup(serialNumber?: string, customerTrackerId?: string, isMultiTripSerial?: boolean): void;
}
